export const SpinnerSize = {
    'spinner-small': 'spinner-small',
    'spinner-medium': 'spinner-medium',
    'spinner-large': 'spinner-large',
};

export default function Spinner({size, className}) {
    className += ' ' + (SpinnerSize[size] ?? SpinnerSize['spinner-medium']) + ' mx-auto ';
    return <div className={className}/>;
}
